import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WalletApplicationsRow = _resolveComponent("WalletApplicationsRow")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_WalletCard = _resolveComponent("WalletCard")!

  return (_openBlock(), _createBlock(_component_WalletCard, {
    class: _normalizeClass(_ctx.b()),
    title: "Заявки",
    tab: "application"
  }, {
    default: _withCtx(() => [
      (_ctx.displayedHistory.length)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(_ctx.b('table'))
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.b('rows'))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayedHistory, (row, rowIndex) => {
                return (_openBlock(), _createBlock(_component_WalletApplicationsRow, {
                  class: _normalizeClass(_ctx.b('row')),
                  key: rowIndex,
                  row: row
                }, null, 8, ["class", "row"]))
              }), 128))
            ], 2)
          ], 2))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(_ctx.b('empty'))
          }, [
            _createElementVNode("span", {
              class: _normalizeClass(_ctx.b('empty-icon'))
            }, "⇄", 2),
            _createElementVNode("h5", {
              class: _normalizeClass(_ctx.b('empty-title'))
            }, _toDisplayString(_ctx.$t("Пока нет заявок")), 3),
            _createElementVNode("p", {
              class: _normalizeClass(_ctx.b('empty-text'))
            }, _toDisplayString(_ctx.$t("Здесь появятся ваши заявки на обмен")), 3),
            _createVNode(_component_router_link, {
              class: _normalizeClass(_ctx.b('empty-cta')),
              to: { name: 'application' }
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("Обменять")), 1)
              ]),
              _: 1
            }, 8, ["class"])
          ], 2))
    ]),
    _: 1
  }, 8, ["class"]))
}